import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import { uuid } from '../../../../utils.jsx';

var TableWidget = createReactClass({
  propTypes: {
    index: PropTypes.number,
    uuid: PropTypes.string,
    name: PropTypes.string,
    changeObject: PropTypes.func,
    contentSpace: PropTypes.string,
    table: PropTypes.array,
    header: PropTypes.array,
  },

  getDefaultProps: function() {
    return {
      index: 0,
      uuid: '',
      name: '',
      changeObject: function() {},
      data: {
        header: [],
        table: [['', '', ''], ['', '', ''], ['', '', '']],
      },
    };
  },

  getWidgetObject: function() {
    return {
      type: 'table',
      table: this.props.data.table,
      title: this.props.data.title,
      header: this.props.data.header,
      name: this.props.name,
      uuid: this.props.uuid,
    };
  },

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  },

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  },

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  },

  changeTable: function(newTable) {
    var obj = this.getWidgetObject();
    obj.table = [...newTable];
    this.props.changeObject(this.props.index, obj);
  },

  onAddRow: function(e) {
    var table = this.props.data.table;
    if (table[0] === undefined) {
      table.push(['', '', '']);
    } else {
      var row = [];
      for (var i = 0; i < table[0].length; i++) {
        row.push('');
      }
      table.push(row);
    }

    this.changeTable(table);
  },

  addColumn: function(before) {
    var table = this.props.data.table;
    if (table[0] === undefined) {
      table.push(['', '', '']);
    } else {
      for (var i in table) {
        if (before) {
          table[i].unshift('');
        } else {
          table[i].push('');
        }
      }
    }
    this.changeTable(table);
  },

  onRemoveRow: function(rowIdx) {
    var table = [...this.props.data.table];
    table.splice(rowIdx, 1);
    this.changeTable(table);
  },

  onRemoveColumn: function(columnIdx) {
    var table = [];
    for (var i in this.props.data.table) {
      var row = [...this.props.data.table[i]];
      row.splice(columnIdx, 1);
      table.push(row);
    }
    this.changeTable(table);
  },

  onChangeCell: function(e) {
    var rowIdx = e.target.getAttribute('data-row-idx');
    var columnIdx = e.target.getAttribute('data-column-idx');
    var table = this.props.data.table;
    if (table[rowIdx] !== undefined && table[rowIdx][columnIdx] !== undefined) {
      table[rowIdx][columnIdx] = e.target.value;
      this.changeTable(table);
    }
  },

  onChangeHeaderPosition: function(e) {
    var newPosition = e.target.value;
    var obj = this.getWidgetObject();
    var idx = this.props.data.header.indexOf(newPosition);
    if (idx === -1) {
      obj.header.push(newPosition);
    } else {
      obj.header.splice(idx, 1);
    }
    this.props.changeObject(this.props.index, obj);
  },

  onChangeName: function(event) {
    var value = event.target.value;
    var object = this.getWidgetObject();
    object.title = value;
    // console.log(object);
    this.props.changeObject(this.props.index, object);
  },

  onDragStart: function(rowIdx, e) {
    e.dataTransfer.setData('text', rowIdx);
  },

  onDrop: function(e) {
    e.preventDefault();
    // e.target.appendChild(document.getElementById(data));
    let moved_idx = parseInt(e.dataTransfer.getData('text'), 10) || 0;
    let current_idx = parseInt(e.target.id.split('_').pop(), 10) || 0;
    let table = [];

    if (moved_idx > current_idx) {
      // console.log('A ' + moved_idx + ' -> ' + current_idx);
      // vsetky riadky pred tym, na ktorom som to pustil
      for (let i = 0; i < current_idx; i++) {
        table.push(this.props.data.table[i]);
      }
      // posuvany riadok
      table.push(this.props.data.table[moved_idx]);
      // vsetky dalsie riadky okrem posuvaneho
      for (let i = current_idx; i < this.props.data.table.length; i++) {
        if (i !== moved_idx) {
          table.push(this.props.data.table[i]);
        }
      }
      this.changeTable(table);
    } else if (moved_idx < current_idx) {
      // console.log('B ' + moved_idx + ' -> ' + current_idx);
      // vsetky riadky pred tym, na ktorom som to pustil (vratane toho), okrem posuvaneho
      for (let i = 0; i <= current_idx; i++) {
        if (i !== moved_idx) {
          table.push(this.props.data.table[i]);
        }
      }
      // posuvany riadok
      table.push(this.props.data.table[moved_idx]);
      // vsetky riadky nasledujuce za tym, na ktorom som to pustil
      for (let i = current_idx + 1; i < this.props.data.table.length; i++) {
        table.push(this.props.data.table[i]);
      }
      this.changeTable(table);
    }
  },

  onDragOver: function(e) {
    e.preventDefault();
  },

  render: function() {
    var htmlRows = [];
    var rows = this.props.data.table.length;
    var cols =
      this.props.data.table.length > 0 ? this.props.data.table[0].length : 0;

    // Delete buttons at the top
    var htmlRow = [];
    htmlRow.push(<td key="000" className="empty" />);
    for (var i = 0; i < cols; i++) {
      htmlRow.push(
        <th
          key={uuid()}
          className="delete"
          onClick={this.onRemoveColumn.bind(this, i)}
        >
          <span className="fa fa-times" />
        </th>,
      );
    }
    htmlRow.push(<td key="001" className="empty" />);
    htmlRows.push(
      <tr key="0000" className="row">
        {htmlRow}
      </tr>,
    );

    for (var r in this.props.data.table) {
      var row = this.props.data.table[r];
      htmlRow = [];
      htmlRow.push(
        <td key={uuid()} className="handle" id={'handle_' + r}>
          <span className="fa fa-bars" id={'bars_' + r} />
        </td>,
      );
      for (var c in row) {
        var col = row[c];
        var input = (
          <input
            key={uuid()}
            type="text"
            defaultValue={col}
            data-row-idx={r}
            data-column-idx={c}
            onBlur={this.onChangeCell}
          />
        );
        if (
          (r === 0 && this.props.data.header.indexOf('t') !== -1) ||
          (c === 0 && this.props.data.header.indexOf('l') !== -1) ||
          (c === cols - 1 && this.props.data.header.indexOf('r') !== -1) ||
          (r === rows - 1 && this.props.data.header.indexOf('b') !== -1)
        ) {
          var htmlCol = <th key={uuid()}>{input}</th>;
        } else {
          var htmlCol = <td key={uuid()}>{input}</td>;
        }
        htmlRow.push(htmlCol);
      }
      htmlRow.push(
        <td
          key={uuid()}
          className="delete"
          onClick={this.onRemoveRow.bind(this, r)}
        >
          <span className="fa fa-times" />
        </td>,
      );
      htmlRows.push(
        <tr
          data-row-idx={r}
          key={uuid()}
          className="row row-sortable"
          draggable="true"
          onDragStart={this.onDragStart.bind(this, r)}
          id={'row_' + r}
        >
          {htmlRow}
        </tr>,
      );
    }

    var htmlTable = (
      <table
        className="table"
        onDrop={this.onDrop}
        onDragOver={this.onDragOver}
        id={'table_' + uuid()}
      >
        <tbody>{htmlRows}</tbody>
      </table>
    );

    return (
      <div
        data-index={this.props.index}
        style={{ clear: 'both' }}
        className="panel panel-default widget-body widget-table"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong> {this.props.name}</strong>
          </span>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body">
          <div className="form-group">
            <label className="title">Názov</label>
            <input
              onChange={this.onChangeName}
              value={this.props.data.title}
              type="text"
              placeholder="(nepovinné)"
              className="form-control"
              name="widget-text"
            />
          </div>

          <div className="form-group">
            <label className="title">Tabuľka</label>
            {htmlTable}
          </div>

          <div className="form-group">
            <label className="title">Hlavička</label>
            <div className="form-inline row">
              <div className="checkbox col-md-3">
                <label>
                  <input
                    type="checkbox"
                    onChange={this.onChangeHeaderPosition}
                    value="t"
                    checked={this.props.data.header.indexOf('t') !== -1}
                  />{' '}
                  Hore
                </label>
              </div>
              <div className="checkbox col-md-3">
                <label>
                  <input
                    type="checkbox"
                    onChange={this.onChangeHeaderPosition}
                    value="r"
                    checked={this.props.data.header.indexOf('r') !== -1}
                  />{' '}
                  Vpravo
                </label>
              </div>
              <div className="checkbox col-md-3">
                <label>
                  <input
                    type="checkbox"
                    onChange={this.onChangeHeaderPosition}
                    value="b"
                    checked={this.props.data.header.indexOf('b') !== -1}
                  />{' '}
                  Dole
                </label>
              </div>
              <div className="checkbox col-md-3">
                <label>
                  <input
                    type="checkbox"
                    onChange={this.onChangeHeaderPosition}
                    value="l"
                    checked={this.props.data.header.indexOf('l') !== -1}
                  />{' '}
                  Vľavo
                </label>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <a
                href="javascript:;"
                onClick={this.onAddRow}
                className="btn btn-block btn-default"
              >
                <span className="fa fa-plus" /> Riadok
              </a>
            </div>
            <div className="col-md-3">
              <a
                href="javascript:;"
                onClick={this.addColumn.bind(this, true)}
                className="btn btn-block btn-default"
              >
                <span className="fa fa-plus" /> Stĺpec na začiatok
              </a>
            </div>
            <div className="col-md-3">
              <a
                href="javascript:;"
                onClick={this.addColumn.bind(this, false)}
                className="btn btn-block btn-default"
              >
                <span className="fa fa-plus" /> Stĺpec na koniec
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  },
});

export default TableWidget;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleWidgetTable.jsx